import styled from 'styled-components';

export const STAR_SIZE = {
  default: "24px",
  mobile: {
    NPS: "30px",
    default: "40px",
  },
  smallMobile: {
    NPS: "32px",
    default: "44px",
  },
};

const starSizeFor = (sizes, type) =>
  type === "NPS" ? sizes.NPS : sizes.default;

export const RatingBox = styled.div`
  height: 35px;
  width: 35px;
  min-width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  tex-align: center;
`;

export const StarsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .MuiRating-root {
    font-size: ${STAR_SIZE.default};
  }

  .MuiSvgIcon-root {
    font-size: inherit;
  }

  @media screen and (max-width: 991px) {
    .MuiRating-root {
      font-size: ${(props) => starSizeFor(STAR_SIZE.mobile, props.type)};
    }
  }

  @media screen and (max-width: 600px) {
    .MuiRating-root {
      font-size: ${(props) => starSizeFor(STAR_SIZE.smallMobile, props.type)};
    }
  }
`;



